import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/productionData";

import { GET_PRODUCTION_DATA_REQUESTED } from "../types";

function* watchGetProductionData() {
  yield takeEvery(GET_PRODUCTION_DATA_REQUESTED, getProductionData);
}

function* getProductionData(action) {
  try {
    const resp = yield call(apiGetProductionData, action.payload);
    yield put(actions.getProductionDataSucceeded(resp.data.items));
  } catch (err) {
    yield put(actions.getProductionDataFailed());
  }
}

export default function* productionDataSaga() {
  yield all([fork(watchGetProductionData)]);
}

function apiGetProductionData(organizationId) {
  return API_GET("production-data", {
    organizationId: organizationId ? organizationId : null,
    gddk: false,
    page: 0,
    size: 1000,
  });
}
